import { apiGet } from "../../../API/Service/apiClient";

export const handleGetSingleSize_list = async(
  {setSizeData,pid,sizeData}) => {  
  try {    
    const resDataProduct = await apiGet("single_product_size",
     {pid:pid,page:1,limit:100});         
     
    if(resDataProduct?.data.length > 0){
      const merged = sizeData?.map(tItem => {
        const match = resDataProduct?.data?.find(sItem => sItem.sid === tItem.sid);
      
        return match
          ? { ...tItem, ch_price: match.ch_price, ch_mrp: match.ch_mrp }
          : tItem; // unchanged if no match
      });
      setSizeData(merged);
    }
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {    
  }
};